import React from 'react'

export default (props: any) => (
  <svg {...props} width="1200" height="800" viewBox="0 0 1200 800" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1200 0H0V800H1200V0Z" fill="#E30A17" />
    <path
      d="M425 600C535.457 600 625 510.457 625 400C625 289.543 535.457 200 425 200C314.543 200 225 289.543 225 400C225 510.457 314.543 600 425 600Z"
      fill="white"
    />
    <path
      d="M475 560C563.366 560 635 488.366 635 400C635 311.634 563.366 240 475 240C386.634 240 315 311.634 315 400C315 488.366 386.634 560 475 560Z"
      fill="#E30A17"
    />
    <path d="M583.334 400L764.235 458.779L652.431 304.894V495.106L764.235 341.221L583.334 400Z" fill="white" />
  </svg>
)
